
/**
 * @nullable
 */
export type CourseDraftDetailResponseLevel = typeof CourseDraftDetailResponseLevel[keyof typeof CourseDraftDetailResponseLevel] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseDraftDetailResponseLevel = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
  ALL: 'ALL',
} as const;
